import { Component, Input } from '@angular/core';
import { ProtocolTypeItemDto } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-protocol-type-badge',
  templateUrl: './protocol-type-badge.component.html',
  styleUrls: ['./protocol-type-badge.component.scss'],
})
export class ProtocolTypeBadgeComponent {
  @Input()
  @Tracked()
  protocolType?: ProtocolTypeItemDto;
}
